import BaseService from './BaseService'
import * as errors from '../errors'
import _ from 'lodash'
import { decorator as reusePromise } from 'reuse-promise'

export default class DistributionListsService extends BaseService {
  mounted() {
    this._fetched = false
  }

  dispose() {
    this._fetched = false
  }

  @reusePromise()
  /**
   * Find a distributionList
   * @param  {string} id - distributionList ID
   * @param  {Boolean} options.bypassCache - Force fetch from server
   * @param  {Boolean} options.ignoreNotFound - Ignore if not found - promise will return null
   * @return {Promise.<DistributionList,Error>} - a promise with the distributionList, or error
   */
  async find(id: string, options={}) {
    options = _.defaults(options, { ignoreNotFound: false, bypassCache: false, includeMembers: false, includeMetadata: false })
    this.host.requireUser()

    // local first
    let entity = null

    if (!options.bypassCache) {
      entity = this.host.models.DistributionList.get(id)
      if (entity) return entity
    }

    const data = await this.host.api.distributionLists.find(id)

    if (data) {
      entity = this.host.models.DistributionList.inject(data)
      delete entity.$placeholder
    } else if (!options.ignoreNotFound) {
      throw new errors.NotFoundError(this.host.models.DistributionList.name, id)
    }

    return entity
  }

  @reusePromise()
  async findAll() {
    if (this._fetched) return this.getAll()

    let organizations = this.host.models.Organization.getAll()
    if (organizations.length === 0) {
      organizations = await this.host.organizations.findAll()
    }

    const { results } = await this.host.search.query({
      types: ['distributionList'],
      organizationIds: organizations.map(o => o.id),
      query: { displayName: '' },
      followContinuations: true,
    })
    const all = results.map(searchResult => searchResult.entity)

    this._fetched = true

    return all
  }

  getAll() { return this.host.models.DistributionList.getAll() }
  getById(id: string) { return this.host.models.DistributionList.get(id) }
  getMultiById(ids: Array<string>) { return this.host.models.DistributionList.getMulti(ids) }
}
